document.addEventListener('DOMContentLoaded', function () {
  var galleries = document.querySelectorAll('.insta-video-gallery');

  galleries.forEach(function (gallery) {
    var swiperEl = gallery.querySelector('.instaVideoThumbs');
    if (!swiperEl || typeof Swiper === 'undefined') return;

    var sectionId = gallery.dataset.sectionId;

    var columnsMobile = parseInt(gallery.dataset.columnsMobile, 10) || 2;
    var columnsTablet = parseInt(gallery.dataset.columnsTablet, 10) || 3;
    var columnsLaptop = parseInt(gallery.dataset.columnsLaptop, 10) || 3;
    var columnsDesktop = parseInt(gallery.dataset.columnsDesktop, 10) || 4;
    var spaceBetween = parseInt(gallery.dataset.spaceBetween, 10) || 16;

    var showNavigation = gallery.dataset.showNavigation === 'true';
    var showPagination = gallery.dataset.showPagination === 'true';
    var loop = gallery.dataset.loop === 'true';
    var autoplay = gallery.dataset.autoplay === 'true';
    var autoplaySpeed = parseInt(gallery.dataset.autoplaySpeed, 10) || 4000;
    var transitionSpeed = parseInt(gallery.dataset.transitionSpeed, 10) || 600;

    var nextEl = swiperEl.querySelector('.swiper-button-next');
    var prevEl = swiperEl.querySelector('.swiper-button-prev');
    var paginationEl = swiperEl.querySelector('.swiper-pagination');

    var config = {
      slidesPerView: columnsMobile,
      spaceBetween: spaceBetween,
      loop: loop,
      speed: transitionSpeed,
      watchOverflow: true,
      // Breakpoints match the theme's standard responsive tiers:
      // tablet 750px, laptop 990px, desktop 1200px
      breakpoints: {
        750: {
          slidesPerView: columnsTablet,
          spaceBetween: spaceBetween
        },
        990: {
          slidesPerView: columnsLaptop,
          spaceBetween: spaceBetween
        },
        1200: {
          slidesPerView: columnsDesktop,
          spaceBetween: spaceBetween
        }
      }
    };

    if (showNavigation && nextEl && prevEl) {
      config.navigation = {
        nextEl: nextEl,
        prevEl: prevEl
      };
    }

    if (showPagination && paginationEl) {
      config.pagination = {
        el: paginationEl,
        clickable: true
      };
    }

    if (autoplay) {
      config.autoplay = {
        delay: autoplaySpeed,
        disableOnInteraction: false
      };
    }

    var swiperInstance = new Swiper(swiperEl, config);

    // Play every video automatically, regardless of which slides are
    // currently visible. Some browsers ignore the native `autoplay`
    // attribute until the element has been laid out / interacted with,
    // so we explicitly call play() on all of them as a fallback.
    var videos = swiperEl.querySelectorAll('video');

    function playAllVideos() {
      videos.forEach(function (video) {
        var playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(function () {
            // Autoplay can be blocked (e.g. unmuted or low-power mode);
            // retry once the video is ready.
            video.addEventListener(
              'canplay',
              function () {
                video.play().catch(function () {});
              },
              { once: true }
            );
          });
        }
      });
    }

    swiperInstance.on('init', playAllVideos);
    playAllVideos();

    // React to theme editor changes without a full page reload.
    document.addEventListener('shopify:section:load', function (event) {
      if (event.target.querySelector('[data-section-id="' + sectionId + '"]')) {
        swiperInstance.update();
      }
    });
  });
});